import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import { trackingAction } from '../../infra/api/trackingAction';
import { objectKeysToSnakeCaseV2 } from 'keys-converter';

export enum EventNm {
  SessionStart = 'session_start',
  ViewPage = 'view_page',
  Scroll10p = 'scroll_10p',
  ClkBtn = 'clk_btn',
  ClkBnr = 'clk_bnr',
  AlertErrorMsg = 'alert_error_msg',
  CertCellSucc = 'cert_cell_succ',
  CertCellFail = 'cert_cell_fail',
  CertCellWait = 'cert_cell_wait',
  PrdlistSucc = 'prdlist_succ',
  PrdlistFail = 'prdlist_fail',
  IssueCatch = 'issue_catch',
  // 주담대
  ViewContent = 'view_content',
  SearchData = 'search_data',
  LandingProduct = 'landing_product',
  // 배너
  ViewBanner = 'view_banner',
  ClkBanner = 'clk_banner',
}

export enum ClkBtnSubEventNm {
  PrmEvnt = 'prm_evt',
  BnkList = 'bnk_list',
  LoanApp = 'loan_app',
  Agree = 'agree',
  Rate = 'rate',
  Limit = 'limit',
  Filter = 'filter',
  Detail = 'detail',
  LoanCncl = 'loan_cncl',
  SchAlertApp = 'sch_alert_app',
  CnclSucc = 'cncl_succ',
  NotiSchAlrt = 'noti_schAlrt',
  IntrstCalc = 'intrst_calc',
  LoanPrg = 'loan_prg',
  LoanPrdPrg = 'loanPrd_prg',
  LoanPrdHit = 'loanPrd_hit',
  LoanPrdComplete = 'loanPrd_complete',
  CardNotiSchAlrt = 'card_noti_schAlrt',
  CardInstrstCalc = 'card_intrst_calc',
  CardFinPrd = 'card_fin_prd',
  DetailList = 'detail_list',
  LoanPrdRecentHit = 'loanPrd_recentHit',
  RateRecord = 'rate_record',
  LimitRecord = 'limit_record',
  EbmpOutlink = 'ebmp_outlink',
  InputBiz = 'input_biz',
  Help = 'help',
  Calc = 'calc',
  CalcOutlink = 'calc_outlink',
  EngagePromotion = 'engage_promtion',
  AgreePromotion = 'agree_promotion',
  // 주담대
  ViewResucc = 'view_resucc',
  ReResucc = 're_resucc',
  GoReqList = 'go_req_list',
  InputResume = 'input_resume',
  InputBegin = 'input_begin',
  SelectAddress = 'select_address',
  InputAddress = 'input_address',
  UnkAddressDtl = 'Unk_address_Dtl',
  Next = 'next',
  MyMtgInfo = 'my_mtg_info',
  GoMtgMain = 'go_mtg_main',
  GoCreMain = 'go_cre_main',
  ViewLoanAppinfo = 'view_loanAppinfo',
  CtaSurvey = 'cta_survey',
  Option = 'option',
  Field = 'field',
  Product = 'product',
  Popup = 'popup',
  HouseList = 'house_list',
  // banner
  Shinhan = 'shinhan',
}

export enum ClkBnrSubEventNm {
  NotiAutoRec = 'noti_auto_rec',
  NotiSchAlrtApp = 'noti_schAlrt_app',
  BnrPromotion = 'bnr_promotion',
}

export enum AlertErrorMsgSubEventNm {
  CertPerson = 'cert_person',
}

export enum ViewContentSubEventNm {
  Product = 'product',
}

export enum SearchDataSubEventNm {
  House = 'house',
}

interface IViewPageProperties {
  pageNm: string;
}

interface IClkBtnProperties {
  btnNm: string;
}

export interface IClkBtnOptionProperties {
  btmsheet_name: string;
  option_name: string;
  before_option_name: string;
}

interface IClkExcuteBtnProperties {
  btnNm: string;
  productSeq: string;
}

interface IClkBnrProperties {
  btnNm: string;
}

interface IAlertErrorMsgProperties {
  msgNm: string;
}

interface IPrdlistSuccFailProperties {
  prdlist: any[];
}

interface IEvents {
  pageName?: string;
  refPageName?: string;
  subEventName?:
    | ClkBtnSubEventNm
    | AlertErrorMsgSubEventNm
    | ClkBnrSubEventNm
    | SearchDataSubEventNm
    | string;
  eventName?: EventNm;
  srcCd?: string;
}

export interface IUseBeaconParam {
  mediaCd?: number | string;
  custSeq?: number | string;
  srcCd?: number | string;
  pageName?: string;
  refPageName?: string;
}

interface ISendParam extends IUseBeaconParam {
  events?: IEvents;
  properties?:
    | IViewPageProperties
    | IClkBtnProperties
    | IClkBtnOptionProperties
    | IAlertErrorMsgProperties
    | IPrdlistSuccFailProperties
    | IClkBnrProperties
    | IClkExcuteBtnProperties
    | {};
}

const useBeacon = (beaconParam?: IUseBeaconParam) => {
  const {
    mediaCd: beaconMediaCd = '',
    custSeq: beaconCustSeq = '',
    srcCd: beaconSrcCd = '',
    pageName: beaconPageName = '',
    refPageName: beaconRefPageName = '',
  } = beaconParam ?? {};

  // todo scroll 10p event, ref_page value 추후 적용
  const send = async (sendParam?: ISendParam) => {
    const events = sendParam?.events ?? {};
    const properties = sendParam?.properties ?? {};

    if (!localStorage.getItem('did')) {
      localStorage.setItem('did', uuidv4());
    }

    if (!sessionStorage.getItem('sid')) {
      sessionStorage.setItem('sid', uuidv4());
    }

    const data: any = {
      device_id: localStorage.getItem('did'),
      session_id: sessionStorage.getItem('sid'),
      media_cd: sendParam?.mediaCd ?? beaconMediaCd ?? '',
      cust_seq: sendParam?.custSeq ?? beaconCustSeq ?? '',
      events: [
        {
          event_id: uuidv4(),
          event_at: moment().format(),
          page_name: events?.pageName ?? beaconPageName ?? '',
          ref_page_name: events?.refPageName ?? beaconRefPageName ?? '',
          sub_event_name: events?.subEventName ?? '',
          event_name: events?.eventName ?? '',
          src_cd: events?.srcCd ?? beaconSrcCd ?? '',
          properties: objectKeysToSnakeCaseV2(properties),
        },
      ],
    };
    // console.log(
    //   'event_name :',
    //   data.events[0].event_name,
    //   '  page_name :',
    //   data.events[0].page_name,
    //   '  properties :',
    //   data.events[0].properties,
    //   'sub_event_name: ',
    //   data.events[0].sub_event_name,
    // );
    trackingAction(data);
  };

  const createSendByEventName = (
    eventName: EventNm,
    subEventName?:
      | ClkBtnSubEventNm
      | AlertErrorMsgSubEventNm
      | ClkBnrSubEventNm
      | SearchDataSubEventNm
  ) => {
    return (param?: ISendParam) => {
      const events = param?.events ?? {};
      const properties = param?.properties ?? {};
      send({
        ...param,
        events: {
          ...events,
          eventName,
          subEventName: subEventName ?? events.subEventName ?? '',
        },
        properties,
      });
    };
  };

  const getParam = () => {
    return {
      beaconMediaCd,
      beaconCustSeq,
      beaconSrcCd,
    };
  };

  return {
    getParam,
    sendSessionStart: createSendByEventName(EventNm.SessionStart),
    sendViewPage: createSendByEventName(EventNm.ViewPage),
    sendViewBanner: createSendByEventName(EventNm.ViewBanner),
    sendViewContent: createSendByEventName(EventNm.ViewContent),
    sendIssueCatch: createSendByEventName(EventNm.IssueCatch),
    sendClkBtn: createSendByEventName(EventNm.ClkBtn),
    sendClkBanner: createSendByEventName(EventNm.ClkBanner),
    // 주담대
    sendClkBtnOption: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.Option,
    ),
    sendClkBtnUnkAddressDtl: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.UnkAddressDtl,
    ),
    sendClkBtnNext: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.Next,
    ),
    sendClkBtnPopup: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.Popup,
    ),
    sendClkBtnInputResume: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.InputResume,
    ),
    sendClkBtnInputBegin: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.InputBegin,
    ),
    //
    sendClkBtnViewResucc: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.ViewResucc,
    ),
    sendClkBtnReResucc: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.ReResucc,
    ),
    sendClkBtnGoReqList: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.GoReqList,
    ),
    //
    sendClkBtnPrmEvnt: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.PrmEvnt,
    ),
    sendClkBtnBnkList: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.BnkList,
    ),
    sendClkBtnLoanApp: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.LoanApp,
    ),
    sendLandingProduct: createSendByEventName(
      EventNm.LandingProduct,
    ),
    sendClkBtnAgree: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.Agree,
    ),
    sendClkBtnRate: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.Rate,
    ),
    sendClkBtnLimit: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.Limit,
    ),
    sendClkBtnFilter: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.Filter,
    ),
    sendClkBtnDetail: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.Detail,
    ),
    sendClkBtnLoanCncl: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.LoanCncl,
    ),
    sendClkBtnCnclSucc: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.CnclSucc,
    ),
    sendClkBtnSchAlertApp: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.SchAlertApp,
    ),
    sendClkBtnDetailList: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.DetailList,
    ),
    sendClkBtnRateRecord: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.RateRecord,
    ),
    sendClkBtnLimitRecord: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.LimitRecord,
    ),

    sendClkBtnNotiSchAlrt: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.NotiSchAlrt,
    ),
    sendClkBtnIntrstCalc: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.IntrstCalc,
    ),
    sendClkBtnLoanPrdRecentHit: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.LoanPrdRecentHit,
    ),
    sendClkBtnLoanPrg: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.LoanPrg,
    ),
    sendClkBtnCardFinPrd: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.CardFinPrd,
    ),
    sendClkBtnCardInstrstCalc: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.CardInstrstCalc,
    ),
    sendClkBtnCardNotiSchAlrt: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.CardNotiSchAlrt,
    ),
    sendClkBtnLoanPrdPrg: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.LoanPrdPrg,
    ),
    sendClkBtnLoanPrdHit: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.LoanPrdHit,
    ),
    sendClkBtnLoanPrdComplete: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.LoanPrdComplete,
    ),
    sendClkBtnEbmpOutlink: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.EbmpOutlink,
    ),
    sendClkBtnInputBiz: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.InputBiz,
    ),
    sendClkBtnHelp: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.Help,
    ),
    sendClkBtnCalc: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.Calc,
    ),
    sendClkBtnCalcOutlink: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.CalcOutlink,
    ),

    sendClkBnrNotiSchAlrtApp: createSendByEventName(
      EventNm.ClkBnr,
      ClkBnrSubEventNm.NotiSchAlrtApp,
    ),
    sendClkBnrNotiAutoRec: createSendByEventName(
      EventNm.ClkBnr,
      ClkBnrSubEventNm.NotiAutoRec,
    ),
    sendClkBnrBnrPromotion: createSendByEventName(
      EventNm.ClkBnr,
      ClkBnrSubEventNm.BnrPromotion,
    ),
    sendClkBtnEngagePromotion: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.EngagePromotion,
    ),
    sendClkBtnAgreePromotion: createSendByEventName(
      EventNm.ClkBtn,
      ClkBtnSubEventNm.AgreePromotion,
    ),
    sendAlertErrorMsg: createSendByEventName(EventNm.AlertErrorMsg),
    sendAlertErrorMsgCertPerson: createSendByEventName(
      EventNm.AlertErrorMsg,
      AlertErrorMsgSubEventNm.CertPerson,
    ),
    sendCertCellSucc: createSendByEventName(EventNm.CertCellSucc),
    sendCertCellFail: createSendByEventName(EventNm.CertCellFail),
    sendCertCellWait: createSendByEventName(EventNm.CertCellWait),
    sendPrdlistSucc: createSendByEventName(EventNm.PrdlistSucc),
    sendSearchEvent: createSendByEventName(EventNm.SearchData),
    sendClkBtnEvent: createSendByEventName(EventNm.ClkBtn),
  };
};

export default useBeacon;
